/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { WrapLoading } from '../helpers/Loading'
import { useNavigationWithModalCloser } from '../../utils/contexts/NavigationContext'

const Link = ({
  block,
  flex,
  color,
  bgColor,
  borderColor,
  loading,
  loadingBgColor,
  loadingColor,
  onClick,
  useOpacity,
  underlineOnHover,
  to,
  href,
  disabled,
  underline,
  ...props
}) => {
  const style = css`
    display: inline;
    text-decoration: ${underline ? 'underline' : 'none'};
    ${block ? `display: block;` : ''}
    ${flex ? `display: flex;` : ''}
		color: ${color} !important;
    line-height: 0;

    &:hover {
      ${useOpacity ? 'opacity: 0.75;' : ''}

      ${underlineOnHover ? 'text-decoration: underline;' : ''}
    }
    ${disabled ? 'cursor: not-allowed;' : ''}
    ${disabled ? 'opacity: .5;' : ''}
  `
  const navigate = useNavigationWithModalCloser()

  let handleClick = e => {
    if (!href && !disabled) {
      e.preventDefault()
      if (!!onClick) {
        onClick(e)
      } else if (!!to) {
        navigate(to)
      }
    }
  }

  if (loading || disabled) handleClick = undefined

  return (
    <WrapLoading loading={loading} bgColor={loadingBgColor} color={loadingColor}>
      <a className="link" css={style} onClick={handleClick} href={href || to} {...props} />
    </WrapLoading>
  )
}

export default Link
